import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { BUSINESS } from "@/lib/site";

const isMobile = () => window.matchMedia("(max-width: 767px)").matches;

const pastHero = () => {
  const hero = document.querySelector('[data-testid="hero-section"]');
  const threshold = hero ? hero.offsetTop + hero.offsetHeight - 80 : window.innerHeight;
  return window.scrollY > threshold;
};

export const MobileCallBar = () => {
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();

  useEffect(() => {
    const update = () => setVisible(isMobile() && pastHero());
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle("has-call-bar", visible);
    return () => document.body.classList.remove("has-call-bar");
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="mobile-call-bar"
          initial={reduce ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduce ? { opacity: 0 } : { opacity: 0, y: 24 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className="fixed inset-x-0 bottom-0 z-40 md:hidden"
        >
          <a
            href={BUSINESS.phoneHref}
            data-testid="mobile-call-bar-link"
            className="flex h-16 items-center justify-center gap-2 bg-brand px-4 text-base font-semibold text-white transition-colors active:bg-brand-dark"
          >
            <Phone size={20} strokeWidth={2} aria-hidden="true" />
            Call {BUSINESS.founderFirstName} for a Free Quote
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
